<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<template>
  <div>
    <transactions :isCurrentUser="true" @initFilters="initFilters" @getData="getdata">
      <div class="vx-col md:w-5/12 ml-5">
        <div class="vx-row mb-2">
          <div class="vx-col sm:w-3/12 flex-inline">
            <span>حساب:</span>
          </div>
          <div class="vx-col sm:w-9/12 flex-inline">
            <select-account
              title=""
              v-model="accountId"
            />
          </div>
        </div>
      </div>
    </transactions>
  </div>
</template>
<style>
</style>
<script>
import Transactions from "./Transactions.vue";
export default {
  components: {
    Transactions,
  },
  data() {
    return {
      accountId: "",
    };
  },
  methods: {
    initFilters() {
      if (Object.keys(this.$route.query).length != 0) {
        this.accountId = this.$route.query.a || this.accountId;
      }
    },
    getdata(e) {
      e.payload.params.accountId=this.accountId;
      e.payload.params.OnlySource = false;
      if (this.accountId) e.query.a = this.accountId;
    },
  },
  mounted(){
      const selectedAccount = this.$store.getters["account/default"];
      if (selectedAccount) {
        this.accountId=selectedAccount.id;
      }
  }
};
</script>
